// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2Dziv","detailsBorder":"styles_detailsBorder__2kKe6"};